import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const ShowPhoneNumber = styled.div`
  display: block;
  width: 100%;

  @media (${mobileXXLargeMax}) {
    display: none;
  }
`;

export const CallAgentBox = styled.div`
  display: none;
  width: 100%;

  @media (${mobileXXLargeMax}) {
    display: block;
  }
`;
